import { render, staticRenderFns } from "./ChallengeSales.vue?vue&type=template&id=11e96090"
import script from "./ChallengeSales.vue?vue&type=script&lang=js"
export * from "./ChallengeSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports